module.exports = __webpack_public_path__ + "static/media/DeliverooProviderLogo.2f726a32.png";